import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';
import { MonthlyResultResponse } from '../types';

type Params = {
  managerId: number | null;
  year: number;
  month: number;
};

const getManagerMonthlyResult = async ({ managerId, year, month }: Params) => {
  const { data } = await api.get<MonthlyResultResponse>(
    `${BI_BASE_URL}/managers/manager/${managerId}/result/monthly`,
    {
      params: { year, month },
    }
  );

  return data;
};

export const useGetManagerMonthlyResult = ({
  managerId,
  year,
  month,
}: Params): UseQueryResult<MonthlyResultResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.MONTHLY_RESULT, managerId, year, month],
    queryFn: () => {
      return getManagerMonthlyResult({ managerId, year, month });
    },
    enabled: managerId !== null,
  });
};
